dmx.Attribute('animate-enter', 'mounted', function (node, attr) {
  const { value, modifiers } = attr;
  const { delay, duration, random } = modifiers;
  dmx.animate(node, value, duration, (random ? Math.random() * 10 : this.data.$index) * delay);
});